module.exports = __webpack_public_path__ + "img/電気回路_2_9_2.12fce34b.png";